module.exports = __webpack_public_path__ + "img/google_chat.7fa13acd.svg";